(function () {
  if (window.__block2VolumePriceSyncInitialized) return;
  window.__block2VolumePriceSyncInitialized = true;

  function getSelectedVolumePrice() {
    var selectedItem = document.querySelector('.ab-volume-discount-item-selected');
    if (!selectedItem) return null;

    var priceEl = selectedItem.querySelector(
      '.ab-volume-discount-item-discount-price .volume-discount-price, .ab-volume-discount-item-discount-price, .volume-discount-price'
    );

    if (!priceEl) return null;

    var priceText = priceEl.textContent ? priceEl.textContent.trim() : '';
    return priceText || null;
  }

  function getSelectedSubscriptionPrice() {
    var selectedSubscription = document.querySelector('.subscription-custom__card--subscription input[type="radio"]:checked');
    if (selectedSubscription) {
      var subscriptionCard = selectedSubscription.closest('.subscription-custom__card--subscription');
      if (subscriptionCard && subscriptionCard.dataset.subscriptionVisiblePrice) {
        return subscriptionCard.dataset.subscriptionVisiblePrice;
      }
    }

    var selectedOneTime = document.querySelector('.subscription-custom__card--one-time input[type="radio"]:checked');
    if (selectedOneTime) {
      var oneTimeCard = selectedOneTime.closest('.subscription-custom__card--one-time');
      if (oneTimeCard && oneTimeCard.dataset.oneTimeVisiblePrice) {
        return oneTimeCard.dataset.oneTimeVisiblePrice;
      }
    }

    return null;
  }

  var observedVolumeRoots = new WeakSet();
  var volumeRootDiscoveryObserver = null;
  var volumeRootDiscoveryTimer = null;
  var sectionReloadTimer = null;
  var pendingUpdate = false;
  var DISCOVERY_TIMEOUT_MS = 10000;

  function normalizeAppstlePrices(root) {
    var priceNodes = root.querySelectorAll(
      '.volume-discount-price, .volume-original-price'
    );

    priceNodes.forEach(function (node) {
      var currentText = node.textContent ? node.textContent.trim() : '';
      var normalizedText = currentText.replace(/,00(?=\s*$)/, '');

      if (normalizedText !== currentText) {
        node.textContent = normalizedText;
      }
    });
  }

  function scheduleUpdate() {
    if (pendingUpdate) return;
    pendingUpdate = true;

    window.requestAnimationFrame(function () {
      pendingUpdate = false;
      updateButtonPrices();
    });
  }

  function observeVolumeRoot(root) {
    if (!root || observedVolumeRoots.has(root)) return false;

    observedVolumeRoots.add(root);
    normalizeAppstlePrices(root);

    var observer = new MutationObserver(function () {
      normalizeAppstlePrices(root);
      scheduleUpdate();
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'aria-checked', 'data-state']
    });

    return true;
  }

  function discoverVolumeRoots() {
    var roots = document.querySelectorAll('.ab-volume-discount-rule-content');
    var discoveredNewRoot = false;
    roots.forEach(function (root) {
      if (observeVolumeRoot(root)) discoveredNewRoot = true;
      normalizeAppstlePrices(root);
    });
    return discoveredNewRoot;
  }

  function stopVolumeRootDiscovery() {
    if (volumeRootDiscoveryObserver) {
      volumeRootDiscoveryObserver.disconnect();
      volumeRootDiscoveryObserver = null;
    }

    if (volumeRootDiscoveryTimer) {
      window.clearTimeout(volumeRootDiscoveryTimer);
      volumeRootDiscoveryTimer = null;
    }
  }

  function watchForVolumeRoots() {
    discoverVolumeRoots();
    if (volumeRootDiscoveryObserver) return;

    volumeRootDiscoveryObserver = new MutationObserver(function () {
      if (discoverVolumeRoots()) scheduleUpdate();
    });

    volumeRootDiscoveryObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    volumeRootDiscoveryTimer = window.setTimeout(
      stopVolumeRootDiscovery,
      DISCOVERY_TIMEOUT_MS
    );
  }

  function syncSupplySelectionForms() {
    var hasSelectedSupply = !!document.querySelector('.ab-volume-discount-item-selected');
    var forms = document.querySelectorAll('form[data-requires-supply-selection="true"]');

    forms.forEach(function (form) {
      var button = form.querySelector('[data-add-to-cart]');
      if (!button) return;

      var label = button.querySelector('[data-add-to-cart-text]');
      var price = button.querySelector('[data-button-price]');
      var separator = button.querySelector('[data-supply-selection-separator]');
      var quickPay = form.querySelector('[data-supply-selection-quick-pay]');
      var originalLabel = button.dataset.supplySelectionOriginalLabel || '';
      var variantAvailable = button.dataset.supplySelectionVariantAvailable === 'true';

      if (!hasSelectedSupply) {
        button.dataset.supplySelectionLocked = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-label', 'Elige tu suministro');
        button.style.background = '#a6a6a6';
        button.style.borderColor = '#a6a6a6';
        button.style.color = '#ffffff';
        button.style.boxShadow = 'none';
        button.style.opacity = '1';
        if (label) label.textContent = 'Elige tu suministro';
        if (price) price.hidden = true;
        if (separator) separator.hidden = true;
        if (quickPay) quickPay.hidden = true;
        return;
      }

      button.dataset.supplySelectionLocked = 'false';
      button.disabled = !variantAvailable;
      button.setAttribute('aria-disabled', variantAvailable ? 'false' : 'true');
      button.setAttribute('aria-label', originalLabel);
      button.style.removeProperty('background');
      button.style.removeProperty('border-color');
      button.style.removeProperty('color');
      button.style.removeProperty('box-shadow');
      button.style.removeProperty('opacity');
      if (label) label.textContent = originalLabel;
      if (price) price.hidden = false;
      if (separator) separator.hidden = false;
      if (quickPay) quickPay.hidden = !variantAvailable;
    });
  }

  function updateButtonPrices() {
    discoverVolumeRoots();

    var selectedVolumePrice = getSelectedVolumePrice();
    var selectedSubscriptionPrice = getSelectedSubscriptionPrice();
    var priceNodes = document.querySelectorAll('[data-button-price]');

    priceNodes.forEach(function (node) {
      if (!node.dataset.defaultPriceText) {
        node.dataset.defaultPriceText = node.textContent.trim();
      }

      if (selectedVolumePrice) {
        node.textContent = selectedVolumePrice;
        node.dataset.volumeOverride = 'true';
      } else if (selectedSubscriptionPrice) {
        node.textContent = selectedSubscriptionPrice;
        node.dataset.volumeOverride = 'true';
      } else if (node.dataset.volumeOverride === 'true') {
        node.textContent = node.dataset.defaultPriceText;
        node.dataset.volumeOverride = 'false';
      }
    });

    syncSupplySelectionForms();
  }

  function bindVolumeEvents() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('.ab-volume-discount-item-container')) {
        watchForVolumeRoots();
        window.setTimeout(scheduleUpdate, 50);
      }

      if (event.target.closest('.subscription-custom__card')) {
        window.setTimeout(scheduleUpdate, 50);
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.closest('.ab-volume-discount-item-container')) {
        watchForVolumeRoots();
        window.setTimeout(scheduleUpdate, 50);
      }

      if (event.target.closest('.subscription-custom__card')) {
        window.setTimeout(scheduleUpdate, 50);
      }
    });

    function initializeVolumeSync() {
      watchForVolumeRoots();
      scheduleUpdate();
    }

    document.addEventListener('shopify:section:load', function () {
      stopVolumeRootDiscovery();
      if (sectionReloadTimer) window.clearTimeout(sectionReloadTimer);
      sectionReloadTimer = window.setTimeout(function () {
        sectionReloadTimer = null;
        initializeVolumeSync();
      }, 100);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeVolumeSync, { once: true });
    } else {
      initializeVolumeSync();
    }
  }

  bindVolumeEvents();
})();
